import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Card,
  Row,
  Col,
  Tag,
  Collapse,
  CollapseItem
} from 'element-ui'

Vue.use(Card)
  .use(Row)
  .use(Col)
  .use(Tag)
  .use(Collapse)
  .use(CollapseItem)
